import { MARQUEE_ITEMS } from "../../config/site";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-ink-line bg-ink-surface py-4" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap font-mono text-sm uppercase tracking-[0.35em] text-ink-muted">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8">{item}</span>
            <span className="text-accent">///</span>
          </span>
        ))}
      </div>
    </div>
  );
};
